import basicController from "servicestack/basic.controller.properties";
import templateUrl from "emun.swatch/swatch-container.htm";

export class SwatchContainerController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    console.debug("SwatchContainerController", this);
  }

  getImageUrl(id, size) {
    return this.$appConfig.productImage(id, size);
  }

  statusLabel(line, mode = this.mode || "covers") {
    const label = (
      line[mode === "covers" ? "status" : "appStatus"] || ""
    ).toUpperCase();
    switch (label) {
      case "MISSING":
        return "INVALID SWATCH";
    }
    return label;
  }

  statusCss(line, mode = this.mode || "covers") {
    switch (
      (line[mode === "covers" ? "status" : "appStatus"] || "").toUpperCase()
    ) {
      case "ACTIVE":
        return "success";
      case "MISSING":
      case "BAD SCAN":
      case "INACTIVE":
        return "danger";
      case "DUPLICATE":
        return "duplicate";
      case "DISCONTINUED":
        return "warning";
    }
    return "default";
  }
}

export default {
  controller: SwatchContainerController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
